export default __webpack_public_path__ + "transfix-maps/icons/P4-newWave.5bb03a6064e97deda9a7e446a3fd1898.png";